import { Injectable } from '@angular/core';
import { RightLevel } from '../models/RightLevel.enum';
import { Right } from '../models/Rights.enum';
import { UserRights } from './UserRights.model';
import { UserService } from './user.service';

@Injectable()
export class RightsService {
  private userRights: { [id: string]: RightLevel } = {};
  rightType = Right;

  constructor(private userService: UserService) { }

  private hasRights(right: Right, rightLevel: RightLevel) {
    if (right !== undefined && this.userRights[this.rightType[right]] != null) {
      return this.userRights[this.rightType[right]] >= rightLevel;
    }
    return false;
  }

  public hasReadRights(right: Right) {
    return this.hasRights(right, RightLevel.READONLY);
  }

  public hasReadWriteRights(right: Right) {
    return this.hasRights(right, RightLevel.READWRITE);
  }

  public hasAccessRights(right: Right) {
    return this.hasRights(right, RightLevel.READONLY);
  }

  refreshUserRights() {
    let userRights;

    const bomsRights = this.userService.BomsRights;
    if (bomsRights) {
      const splittedToken: string[] = bomsRights.split('+');
      userRights = new UserRights(Number(splittedToken[0]),
        Number(splittedToken[1]),
        Number(splittedToken[2]),
        Number(splittedToken[3]),
        Number(splittedToken[4]));
    } else if (this.userService.isMonitoringMode()) {
      userRights = new UserRights(RightLevel.READONLY,
        RightLevel.READONLY,
        RightLevel.READONLY,
        RightLevel.READONLY,
        RightLevel.READONLY);
    } else {
      userRights = new UserRights(RightLevel.NONE,
        RightLevel.NONE,
        RightLevel.NONE,
        RightLevel.NONE,
        RightLevel.NONE);
    }
    this.userRights = userRights.RightsAsDictionnary;
  }
}
